import { render, staticRenderFns } from "./ispDeleteService.vue?vue&type=template&id=23a789d3&scoped=true&"
import script from "./ispDeleteService.vue?vue&type=script&lang=js&"
export * from "./ispDeleteService.vue?vue&type=script&lang=js&"
import style0 from "./ispDeleteService.vue?vue&type=style&index=0&id=23a789d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a789d3",
  null
  
)

export default component.exports